import { Field, Form, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Carousel } from "react-bootstrap";
import { FaAngleDoubleDown } from "react-icons/fa";
import { useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../utils/CommonHelper";
import { Input } from "../../../common/components/control/InputField";
import { GameItem } from "../../../common/components/GameListing";
import {
  fetchDemoCompanyGame,
  fetchIPAddress,
  login,
} from "../../api/loginapi";
import { LoginTab } from "../../enum/LoginTab";
import { LoginSchema } from "../../yupSchema/loginSchema";
import { useAuth } from "../AuthInit";

export const LoginFormTab = ({
  setSwalProps,
  setLoginTab,
  setShowRegisterFgtPassword,
  showRegisterFgtPassword,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isShowMore, setIsShowMore] = useState(
    location.state?.isShowMore === "true"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingGame, setIsLoadingGame] = useState(false);
  const [companyCode, setCompanyCode] = useState(location.state?.companyCode);
  const [selectedGame, setSelectedGame] = useState(
    sessionStorage.getItem("lastSelectGame")
  );
  const { saveAuth, setCurrentUser, promoShow, setPromoShow } = useAuth();
  const intl = useIntl();
  const currentLocale = localStorage.getItem("locale");
  const ipaddress = useRef("");
  const isInitial = useRef(true);
  const slideStyle = { width: "30%", height: "50px" };

  useEffect(() => {
    fetchIPAddress().then((res) => {
      ipaddress.ip = res.ip;
      localStorage.setItem("ipaddress", ipaddress.ip);
      if (!promoShow) {
        const modalTrigger = document.getElementById("modalTrigger");
        if (modalTrigger) {
          modalTrigger.click();
        }
        setPromoShow(true);
      }
    });
  }, []);

  useEffect(() => {
    if (showRegisterFgtPassword && location.state && isInitial.current) {
      if (document.querySelector("#root"))
        document.querySelector("#root").scrollTo({
          top: parseInt(location.state.scrollPosition),
          behavior: "smooth",
        });
      isInitial.current = false;
    }
  }, [showRegisterFgtPassword]);

  const handleLanguageChange = (language) => {
    if (sessionStorage.getItem("platform") === "mobile") {
      localStorage.setItem("locale", language);
    } else {
      localStorage.setItem("locale", language);
      window.location.reload();
    }
  };

  const handlePlayGame = (gameCode) => {
    sessionStorage.setItem("lastSelectGame", gameCode);
    const currentScrollPosition = document.querySelector("#root")
      ? document.querySelector("#root").scrollTop
      : window.scrollY || document.documentElement.scrollTop;

    navigate(
      `/gamePlay/${companyCode}/${gameCode}/0/${currentScrollPosition}/1?isShowMore=${isShowMore}`
    );
  };

  useEffect(() => {
    if (
      showRegisterFgtPassword?.demoCompany?.demoCompanyLists &&
      !companyCode
    ) {
      setCompanyCode(
        showRegisterFgtPassword?.demoCompany?.demoCompanyLists[0].companycode
      );
    }
  }, [showRegisterFgtPassword]);

  const gameList =
    showRegisterFgtPassword?.demoCompany?.demoSlotGameLists ?? [];

  return (
    <div className="d-flex flex-column align-items-stretch justify-content-center">
      <div className="d-flex mb-4 align-items-center justify-content-center mt-5 pt-5">
        <img
          src={`${process.env.PUBLIC_URL}/image/${process.env.REACT_APP_IMAGE_PATH}/2a.png`}
          style={{ height: "60px" }}
        />
      </div>
      <Formik
        initialValues={{ username: "", userPassword: "" }}
        enableReinitialize={true}
        validationSchema={LoginSchema(intl)}
        onSubmit={(values, formikHelpers) => {
          setIsLoading(true);
          fetchIPAddress()
            .then((res) => {
              const queryParams = {
                action: "memberlogin",
                username: values.username,
                password: values.userPassword,
                language: intl.locale,
                fcmnotificationid: "",
                ipaddress: res.ip,
              };

              login(queryParams)
                .then((resp) => {
                  setIsLoading(false);
                  if (parseInt(resp.code) === 0) {
                    saveAuth(resp);
                    setCurrentUser(resp);
                    handleLanguageChange(resp.languagecode);
                    sessionStorage.removeItem("lastSelectGame");
                  } else {
                    formikHelpers.setFieldValue("userPassword", "");
                    setSwalProps({
                      show: true,
                      icon: "error",
                      title: intl.formatMessage({ id: "error" }),
                      text: resp.message,
                    });
                  }
                })
                .catch((error) => {
                  setIsLoading(false);
                });
            })
            .catch((error) => {
              setIsLoading(false);
            });
        }}
      >
        {({
          values,
          handleSubmit,
          setFieldValue,
          touched,
          errors,
          setFieldError,
        }) => (
          <Form>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: "2%",
              }}
            >
              <div
                style={{
                  paddingLeft: "5%",
                  paddingRight: "5%",
                  width: "90%",
                  boxSizing: "border-box",
                }}
              >
                <label
                  className="mb-2 text-input-label"
                  style={{ color: "white" }}
                >
                  {intl.formatMessage({ id: "username" })}
                </label>
                <div className="mb-2">
                  <Field
                    name="username"
                    component={Input}
                    placeholder={intl.formatMessage({ id: "username" })}
                    autoComplete="off"
                    pattern="[a-zA-Z0-9]*"
                  />
                </div>
              </div>
              <div
                style={{
                  paddingLeft: "5%",
                  paddingRight: "5%",
                  width: "90%",
                  boxSizing: "border-box",
                }}
              >
                <label
                  className="mb-2 text-input-label"
                  style={{ color: "white" }}
                >
                  {intl.formatMessage({ id: "password" })}
                </label>
                <div className="mb-2">
                  <Field
                    name="userPassword"
                    component={Input}
                    placeholder={intl.formatMessage({ id: "password" })}
                    autoComplete="off"
                    type="password"
                  />
                </div>
              </div>
            </div>
            {showRegisterFgtPassword?.forgetpasswordsms === "true" && (
              <div
                style={{
                  paddingTop: "2%",
                }}
                className="d-flex align-items-center flex-column"
              >
                <div style={{ width: "80%" }}>
                  <p
                    style={{
                      fontSize: 13,
                    }}
                    className="text-startt text-light"
                  >
                    <div
                      style={{
                        cursor: "pointer",
                        background: "none",
                      }}
                      className="border-0 text-light text-decoration-underline"
                      onClick={() => {
                        setLoginTab(LoginTab.FORGOT_PASSWORD_PART_1);
                      }}
                    >
                      {intl.formatMessage({ id: "forgetpassword" })}
                    </div>
                  </p>
                </div>
              </div>
            )}

            <div
              style={{
                paddingTop: "2%",
              }}
              className="d-flex align-items-center flex-column"
            >
              <button
                type="submit"
                disabled={isLoading}
                style={{
                  width: "60%",
                  height: 35,
                  borderRadius: 15,
                  backgroundColor: "rgb(245, 190, 9)",
                  fontWeight: "bold",
                  color: "black",
                  fontSize: "12px",
                }}
              >
                {isLoading ? (
                  <div
                    className="spinner-border"
                    role="status"
                    style={{ scale: "0.75" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : (
                  <div>
                    <span style={{ flex: 1, textAlign: "center" }}>
                      {intl.formatMessage({ id: "login" })}
                    </span>
                  </div>
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>

      <div
        style={{
          margin: "0 auto",
          width: "90%",
          marginTop: 20,
          marginBottom: 20,
          padding: 5,
        }}
        className="d-flex align-items-center justify-content-center"
      >
        {currentLocale !== "ms" && (
          <img
            src={`${process.env.PUBLIC_URL}/image/my.png`}
            style={{ height: "30px", width: "30px", marginLeft: "10px" }}
            onClick={() => handleLanguageChange("ms")}
          />
        )}
        {currentLocale !== "en" && (
          <img
            src={`${process.env.PUBLIC_URL}/image/en.png`}
            style={{ height: "30px", width: "30px", marginLeft: "10px" }}
            onClick={() => handleLanguageChange("en")}
          />
        )}
        {currentLocale !== "zh" && (
          <img
            src={`${process.env.PUBLIC_URL}/image/cn.png`}
            style={{ height: "30px", width: "30px", marginLeft: "10px" }}
            onClick={() => handleLanguageChange("zh")}
          />
        )}
        {currentLocale !== "id" && (
          <img
            src={`${process.env.PUBLIC_URL}/image/id.png`}
            style={{ height: "30px", width: "30px", marginLeft: "10px" }}
            onClick={() => handleLanguageChange("id")}
          />
        )}
      </div>
      {showRegisterFgtPassword?.registersms === "true" && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <p style={{ color: "white", textAlign: "center", fontSize: 13 }}>
            {intl.formatMessage({ id: "dontHaveAccount" })}{" "}
            <button
              style={{
                cursor: "pointer",
                border: "none",
                background: "none",
                color: "white",
                textDecoration: "underline",
                fontSize: 15,
              }}
              onClick={() => {
                setLoginTab(LoginTab.REGISTER_PART_1);
              }}
            >
              {intl.formatMessage({ id: "signUp" })}
            </button>
          </p>
        </div>
      )}

      <div className="mt-2 ps-3 w-100">
        <Carousel
          indicators={false}
          controls={false}
          data-bs-theme="dark"
          interval={3000}
          pause={false}
          className="w-100"
        >
          <Carousel.Item className="w-100">
            <div className="d-flex justify-content-between position-relative">
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/allbet.webp")}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl(
                    "image/memberDash/gameWebp/dreamgaming.webp"
                  )}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/evo.webp")}
                  className="w-100"
                />
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item className="w-100">
            <div className="d-flex justify-content-between position-relative">
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/ibc.webp")}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/joker.webp")}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/kiss918.webp")}
                  className="w-100"
                />
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item className="w-100">
            <div className="d-flex justify-content-between position-relative">
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/mega.webp")}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl(
                    "image/memberDash/gameWebp/microgaming.webp"
                  )}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/playtech.webp")}
                  className="w-100"
                />
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item>
            <div className="d-flex justify-content-between position-relative">
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl(
                    "image/memberDash/gameWebp/pragmaticplay.webp"
                  )}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl(
                    "image/memberDash/gameWebp/worldentertain.webp"
                  )}
                  className="w-100"
                />
              </div>
              <div
                style={slideStyle}
                className="d-flex align-items-center justify-content-center"
              >
                <img
                  alt=""
                  src={toAbsoluteUrl("image/memberDash/gameWebp/xe88.webp")}
                  className="w-100"
                />
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
      <div className="mt-4 w-100">
        <div className="d-flex align-items-center justify-content-center text-white fs-5 mb-4">
          <div className="d-flex align-items-center justify-content-center gap-1 move-up-down">
            <FaAngleDoubleDown />
            <div>{intl.formatMessage({ id: "demoGames" })}</div>
            <FaAngleDoubleDown />
          </div>
        </div>
        <div
          className="d-flex overflow-auto gap-2 align-items-start p-2"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          {showRegisterFgtPassword?.demoCompany?.demoCompanyLists?.map(
            (demoCompany) => (
              <div
                key={demoCompany.companycode}
                className="col-4 rounded"
                style={
                  demoCompany.companycode === companyCode
                    ? { border: "1px solid #ffa500" }
                    : {}
                }
                onClick={() => {
                  setIsLoadingGame(true);
                  setCompanyCode(demoCompany.companycode);
                  fetchDemoCompanyGame(demoCompany.companycode).then(
                    (demoCompany) => {
                      setIsLoadingGame(false);
                      setShowRegisterFgtPassword((prev) => ({
                        ...prev,
                        demoCompany,
                      }));
                    }
                  );
                }}
              >
                <img src={demoCompany.iconurl} className="w-100" />
              </div>
            )
          )}
        </div>
        {isLoadingGame ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "300px" }}
          >
            <div
              className="spinner-border"
              role="status"
              style={{ scale: "1.2" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="position-relative pb-5">
            <div className="d-flex flex-wrap mt-4 px-2">
              {(isShowMore ? gameList : [...gameList].slice(0, 8)).map(
                (game, index) => (
                  <GameItem
                    key={index}
                    game={game}
                    searchName={""}
                    handlePlayGame={handlePlayGame}
                    gamePerRow={4}
                    selectedGame={selectedGame}
                    setSelectedGame={setSelectedGame}
                    imageStyle={{
                      width: "100%",
                    }}
                  />
                )
              )}
            </div>
            {gameList.length > 8 && (
              <div
                className={`d-flex align-items-center justify-content-center ${
                  !isShowMore ? "position-absolute bottom-0 end-0 start-0" : ""
                }`}
                style={
                  !isShowMore
                    ? {
                        height: "150px",
                        background:
                          "linear-gradient(to bottom,transparent, black, transparent)",
                      }
                    : undefined
                }
              >
                <div
                  className="rounded-pill px-3 py-2 fw-bold"
                  style={{
                    cursor: "pointer",
                    background: "#ffa500",
                    fontSize: "13px",
                  }}
                  onClick={() => setIsShowMore((prev) => !prev)}
                >
                  {intl.formatMessage({
                    id: isShowMore ? "showLess" : "showMore",
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
